"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _createSvgIcon = _interopRequireDefault(require("../utils/createSvgIcon"));

/* eslint-disable prettier/prettier */
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M9.80276276,5.44074789 L10.8807628,5.44074789 L10.8807628,3.80274789 C10.7127628,3.80274789 10.5307628,3.76074789 10.3557628,3.75374789 C10.0337628,3.75374789 9.71176276,3.71874789 9.38976276,3.75374789 C8.890095,3.74736927 8.40081942,3.89659832 7.98976276,4.18074789 C7.53662382,4.51562287 7.24060222,5.02164271 7.17076276,5.58074789 C7.134733,5.81236612 7.1160145,6.04634741 7.11476276,6.28074789 C7.11476276,6.65174789 7.11476276,6.98074789 7.11476276,7.38674789 L7.11476276,7.52674789 L5.53976276,7.52674789 L5.53976276,9.35374789 L7.09376276,9.35374789 L7.09376276,13.9457479 L8.99776276,13.9457479 L8.99776276,9.29774789 L10.5517628,9.29774789 C10.6287628,8.68874789 10.7057628,8.08674789 10.7897628,7.45674789 L8.98376276,7.45674789 C8.98376276,7.45674789 8.98376276,6.55374789 8.98376276,6.16174789 C9.01876276,5.60174789 9.33376276,5.45474789 9.80276276,5.44074789 Z"
}), 'Facebook', {
  viewBox: '3 3 10 10'
});

exports.default = _default;